/**
 * ThemeToggle — light / system / dark, in the rail footer (brief-28).
 *
 * Three states rather than a switch: "system" has to be reachable, otherwise a
 * user who once clicked dark can never hand control back to their OS.
 */

import { t } from '../i18n';
import type { ThemeChoice } from '../hooks/useCatalogPrefs';

interface ThemeToggleProps {
  choice: ThemeChoice;
  onChange: (choice: ThemeChoice) => void;
}

export default function ThemeToggle({ choice, onChange }: ThemeToggleProps) {
  const options = [
    { value: 'light' as const,  mark: '☀', label: t('theme.light') },
    { value: 'system' as const, mark: '◐', label: t('theme.system') },
    { value: 'dark' as const,   mark: '☾', label: t('theme.dark') },
  ];

  return (
    <div className="dp-theme" role="group" aria-label={t('theme.label')}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={`dp-theme__btn${choice === o.value ? ' dp-theme__btn--on' : ''}`}
          aria-pressed={choice === o.value}
          aria-label={o.label}
          title={o.label}
          onClick={() => onChange(o.value)}
        >
          <span aria-hidden="true">{o.mark}</span>
        </button>
      ))}
    </div>
  );
}
